module.exports={render:function (){var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;
  return _vm._m(0)
},staticRenderFns: [function (){var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;
  return _c('div', {
    staticClass: "chapter"
  }, [_c('div', {
    staticClass: "inner_page"
  }, [_c('div', {
    staticClass: "Basic-Text-Frame"
  }, [_c('p', {
    staticClass: "CT",
    attrs: {
      "id": "_idParaDest-2"
    }
  }), _vm._v(" "), _c('p', {
    staticClass: "BT1stpara ParaOverride-1"
  }, [_c('span', {
    staticClass: "CharOverride-1"
  }, [_vm._v("Also by Jim Harrison")])]), _vm._v(" "), _c('p', {
    staticClass: "BT1stpara ParaOverride-2"
  }, [_c('span', {
    staticClass: "CharOverride-2"
  }, [_vm._v("FICTION")])]), _vm._v(" "), _c('p', {
    staticClass: "BT1stpara ParaOverride-1"
  }, [_c('span', {
    staticClass: "CharOverride-3"
  }, [_vm._v("Wolf: A False Memoir")])]), _vm._v(" "), _c('p', {
    staticClass: "BT1stpara ParaOverride-1"
  }, [_c('span', {
    staticClass: "CharOverride-3"
  }, [_vm._v("A Good Day to Die ")])]), _vm._v(" "), _c('p', {
    staticClass: "BT1stpara ParaOverride-1"
  }, [_c('span', {
    staticClass: "CharOverride-3"
  }, [_vm._v("Farmer")])]), _vm._v(" "), _c('p', {
    staticClass: "BT1stpara ParaOverride-1"
  }, [_c('span', {
    staticClass: "CharOverride-3"
  }, [_vm._v("Warlock")])]), _vm._v(" "), _c('p', {
    staticClass: "BT1stpara ParaOverride-1"
  }, [_c('span', {
    staticClass: "CharOverride-3"
  }, [_vm._v("Sundog")])]), _vm._v(" "), _c('p', {
    staticClass: "BT1stpara ParaOverride-1"
  }, [_c('span', {
    staticClass: "CharOverride-3"
  }, [_vm._v("Dalva")])]), _vm._v(" "), _c('p', {
    staticClass: "BT1stpara ParaOverride-1"
  }, [_c('span', {
    staticClass: "CharOverride-3"
  }, [_vm._v("The Woman Lit by Fireflies")])]), _vm._v(" "), _c('p', {
    staticClass: "BT1stpara ParaOverride-1"
  }, [_c('span', {
    staticClass: "CharOverride-3"
  }, [_vm._v("Julip")])]), _vm._v(" "), _c('p', {
    staticClass: "BT1stpara ParaOverride-1"
  }, [_c('span', {
    staticClass: "CharOverride-3"
  }, [_vm._v("The Road Home")])]), _vm._v(" "), _c('p', {
    staticClass: "BT1stpara ParaOverride-1"
  }, [_c('span', {
    staticClass: "CharOverride-3"
  }, [_vm._v("The Beast God Forgot to Invent")])]), _vm._v(" "), _c('p', {
    staticClass: "BT1stpara ParaOverride-1"
  }, [_c('span', {
    staticClass: "CharOverride-3"
  }, [_vm._v("True North")])]), _vm._v(" "), _c('p', {
    staticClass: "BT1stpara ParaOverride-1"
  }, [_c('span', {
    staticClass: "CharOverride-3"
  }, [_vm._v("The Summer He Didn’t Die")])]), _vm._v(" "), _c('p', {
    staticClass: "BT1stpara ParaOverride-1"
  }, [_c('span', {
    staticClass: "CharOverride-3"
  }, [_vm._v("Returning to Earth")])]), _vm._v(" "), _c('p', {
    staticClass: "BT1stpara ParaOverride-1"
  }, [_c('span', {
    staticClass: "CharOverride-3"
  }, [_vm._v("The English Major")])]), _vm._v(" "), _c('p', {
    staticClass: "BT1stpara ParaOverride-1"
  }, [_c('span', {
    staticClass: "CharOverride-3"
  }, [_vm._v("The Farmer’s Daughter")])]), _vm._v(" "), _c('p', {
    staticClass: "BT1stpara ParaOverride-1"
  }, [_c('span', {
    staticClass: "CharOverride-3"
  }, [_vm._v("The Great Leader")])]), _vm._v(" "), _c('p', {
    staticClass: "BT1stpara ParaOverride-1"
  }, [_c('span', {
    staticClass: "CharOverride-3"
  }, [_vm._v("The River Swimmer")])]), _vm._v(" "), _c('p', {
    staticClass: "BT1stpara ParaOverride-1"
  }, [_c('span', {
    staticClass: "CharOverride-3"
  }, [_vm._v("Brown Dog")])]), _vm._v(" "), _c('p', {
    staticClass: "BT1stpara ParaOverride-1"
  }, [_c('span', {
    staticClass: "CharOverride-3"
  }, [_vm._v("The Big Seven")])]), _vm._v(" "), _c('p', {
    staticClass: "BT1stpara ParaOverride-1"
  }, [_c('span', {
    staticClass: "CharOverride-3"
  }, [_vm._v("The Ancient Minstrel")])]), _vm._v(" "), _c('p', {
    staticClass: "BT1stpara ParaOverride-2"
  }, [_c('span', {
    staticClass: "CharOverride-2"
  }, [_vm._v("CHILDREN’S LITERATURE")])]), _vm._v(" "), _c('p', {
    staticClass: "BT1stpara ParaOverride-1"
  }, [_c('span', {
    staticClass: "CharOverride-3"
  }, [_vm._v("The Boy Who Ran to the Woods")])]), _vm._v(" "), _c('p', {
    staticClass: "BT1stpara ParaOverride-2"
  }, [_c('span', {
    staticClass: "CharOverride-2"
  }, [_vm._v("POETRY")])]), _vm._v(" "), _c('p', {
    staticClass: "BT1stpara ParaOverride-1"
  }, [_c('span', {
    staticClass: "CharOverride-3"
  }, [_vm._v("Plain Song")])]), _vm._v(" "), _c('p', {
    staticClass: "BT1stpara ParaOverride-1"
  }, [_c('span', {
    staticClass: "CharOverride-3"
  }, [_vm._v("Locations")])]), _vm._v(" "), _c('p', {
    staticClass: "BT1stpara ParaOverride-1"
  }, [_c('span', {
    staticClass: "CharOverride-3"
  }, [_vm._v("Outlyer and Ghazals")])]), _vm._v(" "), _c('p', {
    staticClass: "BT1stpara ParaOverride-1"
  }, [_c('span', {
    staticClass: "CharOverride-3"
  }, [_vm._v("Letters to Yesenin")])]), _vm._v(" "), _c('p', {
    staticClass: "BT1stpara ParaOverride-1"
  }, [_c('span', {
    staticClass: "CharOverride-3"
  }, [_vm._v("Returning to Earth")])]), _vm._v(" "), _c('p', {
    staticClass: "BT1stpara ParaOverride-1"
  }, [_c('span', {
    staticClass: "CharOverride-3"
  }, [_vm._v("Selected & New Poems: 1961–1981")])]), _vm._v(" "), _c('p', {
    staticClass: "BT1stpara ParaOverride-1"
  }, [_c('span', {
    staticClass: "CharOverride-3"
  }, [_vm._v("The Theory and Practice of Rivers and New Poems")])]), _vm._v(" "), _c('p', {
    staticClass: "BT1stpara ParaOverride-1"
  }, [_c('span', {
    staticClass: "CharOverride-3"
  }, [_vm._v("After Ikky")]), _c('span', {
    staticClass: "CharOverride-4"
  }, [_vm._v("ū")]), _c('span', {
    staticClass: "CharOverride-3"
  }, [_vm._v(" and Other Poems")])]), _vm._v(" "), _c('p', {
    staticClass: "BT1stpara ParaOverride-1"
  }, [_c('span', {
    staticClass: "CharOverride-3"
  }, [_vm._v("The Shape of the Journey: New and Collected Poems")])]), _vm._v(" "), _c('p', {
    staticClass: "BT1stpara ParaOverride-1"
  }, [_c('span', {
    staticClass: "CharOverride-3"
  }, [_vm._v("Braided Creek: A Conversation in Poetry,")]), _c('span', {
    staticClass: "CharOverride-5"
  }, [_vm._v(" with Ted Kooser")])]), _vm._v(" "), _c('p', {
    staticClass: "BT1stpara ParaOverride-1"
  }, [_c('span', {
    staticClass: "CharOverride-3"
  }, [_vm._v("Saving Daylight")])]), _vm._v(" "), _c('p', {
    staticClass: "BT1stpara ParaOverride-1"
  }, [_c('span', {
    staticClass: "CharOverride-3"
  }, [_vm._v("In Search of Small Gods")])]), _vm._v(" "), _c('p', {
    staticClass: "BT1stpara ParaOverride-1"
  }, [_c('span', {
    staticClass: "CharOverride-3"
  }, [_vm._v("Songs of Unreason")])]), _vm._v(" "), _c('p', {
    staticClass: "BT1stpara ParaOverride-1"
  }, [_c('span', {
    staticClass: "CharOverride-3"
  }, [_vm._v("Dead Man’s Float")])]), _vm._v(" "), _c('p', {
    staticClass: "BT1stpara ParaOverride-2"
  }, [_c('span', {
    staticClass: "CharOverride-2"
  }, [_vm._v("ESSAYS")])]), _vm._v(" "), _c('p', {
    staticClass: "BT1stpara ParaOverride-1"
  }, [_c('span', {
    staticClass: "CharOverride-3"
  }, [_vm._v("Just Before Dark: Collected Nonfiction")])]), _vm._v(" "), _c('p', {
    staticClass: "BT1stpara ParaOverride-2"
  }, [_c('span', {
    staticClass: "CharOverride-2"
  }, [_vm._v("MEMOIR")])]), _vm._v(" "), _c('p', {
    staticClass: "BT1stpara ParaOverride-1"
  }, [_c('span', {
    staticClass: "CharOverride-3"
  }, [_vm._v("Off to the Side")])])])])])
}]}


//////////////////
// WEBPACK FOOTER
// ../node_modules/vue-loader/lib/template-compiler?{"id":"data-v-11b1c2e5","hasScoped":false,"transformToRequire":{"video":"src","source":"src","img":"src","image":"xlink:href"}}!../node_modules/vue-loader/lib/selector.js?type=template&index=0!./src/components/V4481_eBook1.vue
// module id = 60
// module chunks = 0